export default "__VITE_ASSET__W5IOLaWg__"